import { type MutableRefObject } from 'react';
import { type Maybe } from '@gql/schema';

export enum SectionId {
  Title = 'title',
  Photos = 'photos',
  Property = 'property',
  Facilities = 'facilities',
  Location = 'location',
  Offers = 'offers',
}

export interface CustomRef {
  id: SectionId;
  display: boolean;
  element?: Maybe<HTMLElement>;
}

export const getRefHeight = (ref: MutableRefObject<HTMLElement | null>) => {
  return Math.floor(ref?.current?.getBoundingClientRect().height ?? 0);
};
